import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const bitcoinJourneyRoutes = [
  {
    id: 'bitcoin-import-instructions',
    trackingName: 'Bitcoin Import Instructions',
    path: 'dl/view/bitcoin-import-instructions',
    lazy: async () => ({
      Component: (await import('../components/JourneyBitcoinImportInstructions')).JourneyBitcoinImportInstructions,
    }),
  },
  {
    id: 'bitcoin-buy',
    trackingName: 'Bitcoin Purchase',
    path: 'dl/view/bitcoin/buy',
    lazy: async () => ({
      Component: (await import('../components/JourneyBitcoinPurchase')).JourneyBitcoinPurchase,
    }),
  },
  {
    id: 'bitcoin-sell',
    trackingName: 'Bitcoin Sell',
    path: 'dl/view/bitcoin/sell',
    lazy: async () => ({
      Component: (await import('../components/JourneyBitcoinSell')).JourneyBitcoinSell,
    }),
  },
] as const satisfies JourneyRoute[]
